export default function dispatchShowOverlayEvent(options) {
  const showOverlayEvent = new CustomEvent('overlay:show', {
    detail: options,
  })

  window.dispatchEvent(showOverlayEvent)
}
